export default __webpack_public_path__ + "static/media/sg-flag.ff95836a.svg";